async function execScripts(node) {
	if (!node || !node.children) {
		return;
	}
	const children = [...node.children];
	for (let child of children) {
		if (child.tagName !== 'SCRIPT') {
			await execScripts(child);
			continue;
		}
		try {
			let copy = document.createElement('script');
			copy.text = child.innerHTML;
			[...child.attributes].forEach(attr => copy.setAttribute(attr.name, attr.value));
			// child.parentElement.replaceChild(copy, child);
			// Move all scripts out, directly in the body
			child.remove();
			document.body.appendChild(copy);
			if (copy.src && !copy.hasAttribute('async') && !copy.hasAttribute('defer')) {
				// Meant to be executed synchronously
				await new Promise(res => copy.onload = res);
			}
		} catch (e) {
			console.error('Error in script', e);
		}
	}
}

export default async function(code) {
	const pixelsElem = document.createElement('div');
	pixelsElem.innerHTML = code;
	document.body.appendChild(pixelsElem);
	await execScripts(pixelsElem);
	// If all the children were scripts, do not leave an empty div in the HTML
	if (!pixelsElem.firstChild) {
		pixelsElem.remove();
	}
}